import { Select as AntSelect } from 'antd';
import type { SelectProps } from 'antd';

export interface DSelectProps<T> extends SelectProps<T> {}

export const DarwinSelect = <T,>(props: DSelectProps<T>) => {
  return <AntSelect {...props} />;
};

DarwinSelect.Option = AntSelect.Option;
